<template>
  <v-divider :vertical="vertical" color="border border-opacity-100" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      vertical: {
        default: false,
        type: Boolean,
      },
    },
  })
</script>
